import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { useAuth, useTestsData, SortDirectionEnum } from '@modmd/data'
import { PersonalPageLayout } from 'client-portal/components/PageLayout'
import { TestsDatalist } from 'sharedComponents/TestsDatalist'
import { Container } from 'components/Layout'
import { useSearchState } from 'internal-portal/utils/useSearchState'

export enum SortProps {
  DIRECTION = 'direction',
  SORT_BY = 'sortBy',
}

export enum PaginationProps {
  PAGE = 'page',
}

type PersonalTestsProps = RouteComponentProps

export const PersonalTests: React.VFC<PersonalTestsProps> = () => {
  const auth = useAuth()
  const searchState = useSearchState<{
    [PaginationProps.PAGE]?: string
    [SortProps.SORT_BY]?: string
    [SortProps.DIRECTION]?: SortDirectionEnum
  }>()
  const testsQuery = useTestsData({
    filter: {
      userIds: [auth.data.User.id],
      isParticipant: true,
    },
    sorter: {
      sortBy: 'testedAt',
      direction: SortDirectionEnum.DESC,
    },
    page: Number(searchState.data.page || 1),
  })

  return (
    <PersonalPageLayout>
      <Container>
        <TestsDatalist
          tests={testsQuery.data?.tests.tests || []}
          pagination={testsQuery.data?.tests.pagination}
          isLoading={testsQuery.loading}
          columnLabels={{
            location: null,
            staff: null,
            resultProvisionedAt: null,
            resultReceivedAt: null,
            verified: null,
          }}
          requestDebounceInMs={250}
          onPageChange={(pageNumber) => {
            searchState.setSearchState({ page: pageNumber }, false)
          }}
        />
      </Container>
    </PersonalPageLayout>
  )
}
